// mixins/FeaturedIconsMixin.js
import { mapGetters } from 'vuex'
import { take } from 'lodash'

export const FeaturedIconsMixin = {
  computed: {
    ...mapGetters('iconPopularityList', { popularIconsByType: 'getByType' })
  },

  methods: {
    getFeaturedIcons(iconPackName, iconSetSize = 16) {
      const type = iconPackName === 'brands' ? 'brand' : 'default'
      const icons = this.popularIconsByType(type)
      return take(icons, iconSetSize)
    }
  }
}
